import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useRef, useState, } from 'react';
import ModalHeader from './ModalHeader';
import { ChildrenWrapper, Layer, ModalContent } from './styles';
export const MODAL_ANIMATION_TIME = 0.2;
const ModalBase = ({ title, isOpen, children, titleIcon, leftSpace, className = '', headerButtonText, canCloseViaLayer = true, testId = 'modal-contnet', modalAnimationTime = MODAL_ANIMATION_TIME, onHeaderButtonClick, onClose, shouldHideHeaderBorder = false, headerBackground, }) => {
    const timeoutRef = useRef();
    const [isModalOpenAfterAnimation, setIsModalOpenAfterAnimation] = useState(true);
    const handleContentClick = (e) => {
        e.stopPropagation();
    };
    // Clear possible timeout
    useEffect(() => {
        return () => {
            if (typeof timeoutRef.current === 'number') {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setIsModalOpenAfterAnimation(false);
        if (isModalOpenAfterAnimation !== isOpen)
            return;
        timeoutRef.current = Number(setTimeout(() => {
            onClose(e);
        }, modalAnimationTime * 1000));
    }, [modalAnimationTime, onClose, isModalOpenAfterAnimation, isOpen]);
    const handleLayerClick = (e) => {
        canCloseViaLayer && handleClose(e);
    };
    const handleHeaderButtonClick = () => {
        if (onHeaderButtonClick) {
            onHeaderButtonClick();
        }
        else {
            onClose();
        }
    };
    if (!isOpen)
        return null;
    return (_jsx(Layer, { isOpen: isOpen, "data-cy": "modal-layer", onClick: handleLayerClick, onMouseDown: handleLayerClick, modalAnimationTime: modalAnimationTime, children: _jsxs(ModalContent, { "data-cy": testId, leftSpace: leftSpace, onMouseDown: handleContentClick, onClick: handleContentClick, isOpen: isModalOpenAfterAnimation, modalAnimationTime: modalAnimationTime, children: [_jsx("div", { children: (!!(typeof title === 'string') || titleIcon) && (_jsx(ModalHeader, { title: title, titleIcon: titleIcon, onHeaderButtonClick: handleHeaderButtonClick, headerButtonText: headerButtonText, shouldHideHeaderBorder: shouldHideHeaderBorder, headerBackground: headerBackground })) }), _jsx(ChildrenWrapper, { id: "modal-children", className: `modal-content ${className}`, children: children })] }) }));
};
export default memo(ModalBase);
//# sourceMappingURL=ModalBase.js.map